export const hasRole = (user, key) => {
  if (!user || !user.role) return false;

  if (key === 'admin') {
    // appAdmin ==> admin
    return user.role.admin === true || user.role.appAdmin === true;
  }

  return user.role[key] === true;
};
